import { ThemeProvider } from "@mui/material/styles";
import { Box } from '@mui/material';
import { CacheProvider } from '@emotion/react';
import { BrowserRouter, Route, Routes } from 'react-router';

import AppHeader from './app-shell/customer-app/AppHeader';
import AccessLogs from './page-components/team-dashboard/AccessLogs';
import Dashboard from './app-shell/team-dashboard/Dashboard';
import UserDetails from './page-components/team-dashboard/UserDetails';
import UserManagement from './page-components/team-dashboard/UserManagement';
import LocationManagement from './page-components/team-dashboard/LocationManagement';
import VerifyUsers from './page-components/team-dashboard/VerifyUsers';
import Login from './page-components/team-dashboard/Login';
import AppBody from './app-shell/customer-app/AppBody';
import { AuthProvider } from './contexts/AuthContext';
import { SnackbarProvider } from './contexts/SnackbarContext';
import NotificationSnackbar from './components/NotificationSnackbar';
import createEmotionCache from './createEmotionCache';
import Home from './page-components/customer-app/Home';
import AppFooter from './app-shell/customer-app/AppFooter';
import About from './page-components/customer-app/About';
import Menu from './page-components/customer-app/Menu';
import Order from './page-components/customer-app/Order';
import Careers from './page-components/customer-app/Careers';
import Catering from './page-components/customer-app/Catering';
import DashboardHeader from './app-shell/team-dashboard/DashboardHeader';
import DashboardBody from './app-shell/team-dashboard/DashboardBody';
import theme from './constants/theme';
import DashboardAuthGuard from './components/DashboardAuthGuard';

const emotionCache = createEmotionCache();

function PublicSiteLayout() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh'
      }}
    >
      <AppHeader/>
      <AppBody>
        <Routes>
          <Route index element={<Home/>}/>
          <Route path='/about' element={<About/>}/>
          <Route path='/menu' element={<Menu/>}/>
          <Route path='/order' element={<Order/>}/>
          <Route path='/locations' element={<Order/>}/>
          <Route path='/careers' element={<Careers/>}/>
          <Route path='/catering' element={<Catering/>}/>
          <Route path='/login' element={<Login/>}/>
        </Routes>
      </AppBody>
      <AppFooter/>
    </Box>
  );
}

function DashboardLayout() {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <DashboardHeader />
      <DashboardBody>
        <Box sx={{ minHeight: "100%" }}>
          <Routes>
            <Route index element={<Dashboard/>}/>
            <Route path='verify-users' element={<VerifyUsers/>}/>
            <Route path='access-logs' element={<AccessLogs/>}/>
            <Route path='user-details' element={<UserDetails/>}/>
            <Route path='user-management' element={<UserManagement/>}/>
            <Route path='location-management' element={<LocationManagement/>}/>
          </Routes>
        </Box>
      </DashboardBody>
    </Box>
  );
}

function App() {
  
  return (
    <div className="App">
      <CacheProvider value={emotionCache} >
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            <AuthProvider>
              <SnackbarProvider>
                <Routes>
                  <Route path='/dashboard/*' element={<DashboardAuthGuard><DashboardLayout/></DashboardAuthGuard>} />
                  <Route path='/docs/*' element={null} />
                  <Route path='*' element={<PublicSiteLayout/>}/>
                </Routes>
                <NotificationSnackbar/>
              </SnackbarProvider>
            </AuthProvider>
          </BrowserRouter>
        </ThemeProvider>
      </ CacheProvider>
    </div>
  );
}

export default App;
